import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

i18n
  // detect user language
  // learn more: https://github.com/i18next/i18next-browser-languageDetector
  .use(LanguageDetector)
  // pass the i18n instance to react-i18next.
  .use(initReactI18next)
  // init i18next
  // for all options read: https://www.i18next.com/overview/configuration-options
  .init({
    debug: true,
    fallbackLng: "am",
    interpolation: {
      escapeValue: false,
    },
    resources: {
      // en: {
      //     translation: {
      //         home: 'Home',
      //         services: 'Services',
      //         about: 'About us',
      //         contact: 'Contact us',
      //         language: 'Language',
      //         servicesWeOffer: 'Services We are Offering',
      //         start: 'Get started',
      //         footer_title: 'Want to connect with us?',
      //         pages: 'Pages',
      //         monday: 'Monday',
      //         tuesday: 'Tuesday',
      //         wednesday: 'Wednesday',
      //         thursday: 'Thursday',
      //         friday: 'Friday',
      //         working_hours: 'Working Hours',
      //         address: 'Address',
      //         phone: 'Phone',
      //         email: 'E-mail',
      //         formTitle: 'Write us',
      //         name: 'Your name',
      //         subject: 'Subject',
      //         message: 'Message',
      //         send: 'Send Message',
      //         location: 'Location',
      //     },
      // },
      am: {
        translation: {
          home: "Գլխավոր",
          comp: "ՍԵՎԵՐՍՏՐՈՅ",
          hero_title1: "ՍԵՎԵՐՍՏՐՈՅ",
          hero_title2: "ՍԵՎԵՐՍՏՐՈՅ",
          hero_text1:
            "Լավագույն ինժեներների և ճարտարապետների հետ միասին մենք իրականացնում ենք նախագծեր, որոնք կարող են գերազանցել նաև ձեր սպասելիքները:",
          hero_text2:
            "Մեր հաճախորդներին մենք առաջարկում ենք լավագույ լուծումները",
          services: "Ծառայություններ",
          about: "Մեր մասին",
          about_text:
            "«ՍԵՎԵՐՍՏՐՈՅ» ՓԲԸ-ն հիմնադրվել է 2015թ.-ին Հայաստանում: Բազմապրոֆիլ և մասնագիտացված անձնակազմի տարիների փորձի և պատասխանատվության շնորհիվ մատուցում է բազմազան ծառայություններ, սկսած տարածքների բարեկարգումից, շին.հրապարակների նախապատրաստումից մինչև կապիտալ շինարարության ու լուրջ նախագծերի իրականացում: Տարիների փորձը և ձեռք բերած համբավը մեզ թույլ է տալիս համարձակորեն ստանձնել խոշոր նախագծերի իրականացման աշխատանքներ և հաջողությամբ ավարտել դրանք՝ յուրաքանչյուր անգամ ստանալ կատարյալ արդյունք և գոհացնել մեր հաճախորդներին: Իր գործունեության ընթացքում «ՍԵՎԵՐՍՏՐՈՅ» ՓԲԸ կողմից ինչպես ք.Մոսկվայում, այնպես էլ Մոսկվայի մարզում իրականացվել են բազմաթիվ շին մոնտաժային աշխատանքներ և նախագծեր: 2016-2017 թթ. «ՍԵՎԵՐՍՏՐՈՅ» ՓԲԸ կողմից «Իմ փողոցը» ծրագրի շրջանակներում իրականացվել է փողոցների բարեկարգման, ինչպես նաև Մոսկովյան երկաթգծի Փոքր օղակի տարածքների ընդհանուր բարեկարգման աշխատանքներ: 2017թ. -ին իրականացվել է նաև Տարածաշրջանային նշանակության մշակութային ժառանգության օբյեկտ հանդիսացող ք. Մոսկվա. փող. Տագանսկայա, 15 տարածքի արտաքին ինժեներական ցանցերի կազմակերպման, այգու լուսավորության և համալիր կանաչապատման ու բարեկարգման աշխատանքներ:",
          about_first: "Մեր",
          about_second: "մասին",
          contact: "Կապ",
          language: "Լեզու",
          weoffer: "Մենք առաջարկում ենք",
          servicesWeOffer: "Մեր առաջարկած ծառայությունները",
          start: "Կապ",
          footer_title: "Ցանկանու՞մ եք կապ հաստատել։",
          pages: "Էջեր",
          monday: "Երկուշաբթի",
          tuesday: "Երեքշաբթի",
          wednesday: "Չորեքշաբթի",
          thursday: "Հինգշաբթի",
          friday: "Ուրբաթ",
          working_hours: "Աշխատանքային ժամեր",
          address: "Հասցե",
          phone: "Հեռախոս",
          email: "Էլ․ հասցե",
          formTitle: "Գրեք մեզ",
          formTitle1: "Գրեք",
          formTitle2: "մեզ",
          name: "Անուն",
          subject: "Թեմա",
          message: "Հաղորդագրություն",
          send: "Ուղարկել",
          location: "Գտնվելու վայրը",
          our: "Մեր",
          service: "ծառայությունները",
          why: "Մեր",
          choose: "Առավելություններ",
          choose1: "Բազմամյա փորձ",
          choose2: "Բազմապրոֆիլ և մասնագիտացված անձնակազմ",
          choose3: "Ժամանակակից մոտեցումներ և լուծումներ",
          contactus: "Հետադարձ կապ",
          useful: "Օգտակար հղումներ",
          cont: "Կոնտակտային",
          info: "տվյալներ",
          service1: "Հողային աշխատանքներ",
          service2: "Ապամոնտաժման աշխատանքներ",
          service3: "Ֆասադային աշխատանքներ",
          service4: "Հիմքերի կառուցում",
          service5: "Լուսավորման աշխատանքներ",
          service6: "Տանիքածածկման աշխատանքներ",
          service7: "Տարածքների ընդհանուր բարեկարգում",
          service8: "Կապիտալ շինարարություն",
          service9: "Երկաթբետոնե կոնստրուկցիաների կառուցում",
          visit: "Այցելեք մեզ",
          address_text:
            "Դուք կարող այցելել մեզ հետևյալ հասցեով՝ ՀՀ, ք. Երևան, Վ․ Վաղարշյան 12ա",
          address_txt: "ՀՀ, ք. Երևան, Վ․ Վաղարշյան 12ա",

          call: "ԿԱՊ ՀԱՍՏԱՏԵՔ ՄԵԶ ՀԵՏ",
          call_text:
            "Եթե ձեր մոտ առկա են հարցեր ապա կարող եք զանգել հետևյալ համարին՝ +374-41-786-001",
          write: "ԳՐԵՔ ՄԵԶ",
          write_text:
            "Դուք կարող եք նաև կապ հաստատել մեզ էլեկտրոնային հասցեով՝",
        },
      },
      ru: {
        translation: {
          home: "Главная",
          comp: "СЕВЕРСТРОЙ",
          hero_title1: "СЕВЕРСТРОЙ",
          hero_title2: "СЕВЕРСТРОЙ",
          hero_text1:
            "Вместе с лучшими инженерами и архитекторами мы берем на себя реализацию проектов, которые могут и превзойти ваши ожидания.",
          hero_text2:
            "Вместе с лучшими инженерами и архитекторами мы берем на себя реализацию проектов, которые могут и превзойти ваши ожидания.",
          services: "Услуги",
          about: "О Нас",
          about_text:
            "ЗАО «СЕВЕРСТРОЙ» основано в 2015 году в Армении. Благодаря многолетнему опыту и ответственности разнопрофильного и специализированного персонала, оказывает самые разные услуги, начиная от благоустройства территорий, подготовки строительных площадок до капитального строительства и реализации серьезных проектов. Многолетний опыт и репутация позволяют нам смело браться за выполнение крупных проектов и успешно их реализовывать, каждый раз получая идеальный результат, удовлетворяющий наших клиентов. За время своей деятельности ЗАО «СЕВЕРСТРОЙ» выполнило множество строительно-монтажных работ и проектов как в Москве, так и в Московской области. 2016-2017 ЗАО «СЕВЕРСТРОЙ» выполнило благоустройство улиц в рамках программы «Моя улица», а также работы по общему благоустройству территорий Малого кольца Московской железной дороги. Также в 2017 году компания выполняла работы по устройству наружных инженерных сетей, по устройству освешения, комплексному озеленению и благоустройству территории парка - Объект культурного наследия регионального значения по адресу: г. Москва. ул. Таганская, вл.15.",
          hero_text2: "Мы предлагаем нашим клиентам лучшие решения",
          about_first: "О",
          about_second: "нас",
          contact: "Связаться",
          language: "Язык",
          servicesWeOffer: "Услуги, которые мы предлагаем",
          start: "Связаться с нами",
          weoffer: "Мы предлагаем",
          footer_title: "Вы хотите с нами связаться?",
          pages: "Страницы",
          monday: "Понедельник",
          tuesday: "Вторник",
          wednesday: "Среда",
          thursday: "Четверг",
          friday: "Пятница",
          working_hours: "Рабочие часы",
          address: "Адрес",
          phone: "Телефон",
          email: "E-mail",
          formTitle: "Пишите нам",
          formTitle1: "Пишите",
          formTitle2: "нам",
          name: "Имя",
          subject: "Тема",
          message: "Ваше сообщение",
          send: "Отправить",
          location: "Место нахождения",
          our: "Наши",
          service: "сервисы",
          why: "Наши",
          choose: "Преимущества",
          choose1: "Многолетний опыт",
          choose2: "Многопрофильный и специализированный персонал",
          choose3: "Современные подходы и решения",
          contactus: "Обратная связь",
          useful: "Полезные ссылки",
          cont: "Контактная",
          info: "информация",
          service1: "Земляные работы",
          service2: "Демонтажные работы",
          service3: "Фасадные работы",
          service4: "Устройство фундаментов",
          service5: "Устройство освещения",
          service6: "Кровельные работы",
          service7: "Работы по благоустройству территорий",
          service8: "Капитальное строительство",
          service9: "Строительство железобетонных конструкций",
          visit: "Посетите нас!",
          address_text:
            "Вы можете приехать к нам по следующему адресу: Aдрес: РА, г. Ереван, ул. В. Вагаршяна, стр. 12А",
          address_txt: "РА, г. Ереван, ул. В. Вагаршяна, стр. 12А",
          call: "Звоните нам",
          call_text:
            "Если у вас есть вопросы о сотрудничестве с нами, вы можете позвонить нам по телефону +374-41-786-001",
          write: "Пишите нам",
          write_text: "Вы можете и написать нам по электронной почте",
        },
      },
    },
  });

export default i18n;
